module.exports = __webpack_public_path__ + "img/phemex-view-small.1737bd8f.png";